import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '../../features/content';

export const Route = createFileRoute('/admin/content/settings')({ component: SettingsPage });
